import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: { fontSize: '32px' } }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-600 text-thin text-center truncate"
}
const _hoisted_5 = { class: "ml-2 mr-4" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs truncate"
}
const _hoisted_9 = {
  key: 1,
  class: "px-4 py- h-full flex items-center text-sm justify-center text-center"
}

import { library } from "@fortawesome/fontawesome-svg-core";
import { faDroplet, faWind } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { format, getDay, parseISO } from "date-fns";
import { onMounted, ref, computed } from "vue";
import WeatherRepository from "@/repositories/WeatherRepository";
import logger from "@/services/logger";
import { CurrentWeatherResponse } from "@/types/Weather";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WeatherWidget',
  props: {
    width: {},
    height: {}
  },
  emits: ["delete"],
  setup(__props: any) {

const props = __props;


library.add(faDroplet, faWind);

const isLoading = ref(false);
const weatherData = ref<CurrentWeatherResponse | null>(null);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const iconUrl = computed(() => {
  try {
    if (!weatherData.value) {
      return null;
    }
    return require(`@/assets/imgs/weather_icons/${weatherData.value.item.icon_local}.png`);
  } catch (error) {
    return null;
  }
});

const timestampDate = computed(() =>
  weatherData.value ? parseISO(weatherData.value.item.timestamp) : null,
);

const twoColumns = computed(() => props.width > 400);

const loadData = () => {
  isLoading.value = true;
  return WeatherRepository.getCurrentWeatherForSite(currentCustomerName, currentSiteId)
    .then((data) => {
      weatherData.value = data;
    })
    .catch((error) => {
      logger.error(error);
    })
    .finally(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: isLoading.value,
    onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
  }, {
    default: _withCtx(() => [
      (weatherData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["p-1 h-full flex justify-center gap-2", twoColumns.value ? 'flex-row' : 'flex-col'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col gap-2 justify-center min-w-0", twoColumns.value ? 'flex-1' : ''])
            }, [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.height > 138)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "rounded-full shrink-0 h-16 w-16",
                      src: iconUrl.value,
                      alt: ""
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, _toDisplayString(weatherData.value.item.temperature) + "°C", 1)
              ]),
              (_ctx.height > 156)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-droplet" }),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(weatherData.value.item.rain) + " mm", 1),
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-wind" }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(weatherData.value.item.wind) + " " + _toDisplayString(_ctx.$t("dashboard.project.weather_card.kmh")), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.height > 171 || twoColumns.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex flex-col text-gray-800 text-center mt-2 justify-center min-w-0", twoColumns.value ? 'flex-1' : ''])
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(weatherData.value.meta.location_name), 1),
                  (timestampDate.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t(`calendar.week_days.${_unref(getDay)(timestampDate.value) || 7}.long`)) + ", " + _toDisplayString(_unref(format)(timestampDate.value, "dd.MM.yyyy HH:mm")), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (!weatherData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("dashboard.project.weather_card.no_data")), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})